/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResult
 */
export interface FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResult {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResult
     */
    GameSystemName: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResult
     */
    GameId: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResult interface.
 */
export function instanceOfFxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResult(value: object): value is FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResult {
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined) return false;
    if (!('GameId' in value) || value['GameId'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResultFromJSON(json: any): FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResult {
    return FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResultFromJSONTyped(json, false);
}

export function FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResult {
    if (json == null) {
        return json;
    }
    return {
        
        'GameSystemName': json['GameSystemName'],
        'GameId': json['GameId'],
    };
}

export function FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResultToJSON(json: any): FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResult {
    return FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResultToJSONTyped(json, false);
}

export function FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResultToJSONTyped(value?: FxIdWebFeaturesProfileFetchFxIdGameConnectionFetchGameConnectionSuccessfulResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'GameSystemName': value['GameSystemName'],
        'GameId': value['GameId'],
    };
}

